// extracted by mini-css-extract-plugin
export default {"login":"Login_login__Taf5i","control":"Login_control__kLjCA","invalid":"Login_invalid__AWGdD","actions":"Login_actions__YZPvD"};